import React from 'react';

import TipsAndTutorials from '../../views/TipsAndTutorials/TipsAndTutorials';

const QuickStartGuidePage = () => <TipsAndTutorials isQuickStartGuide />;

export default QuickStartGuidePage;
